export class LogTransaccionFilter {
   fechaDesde: Date;
   fechaHasta: Date;
   mensaje: string;
   emisorId: string;
   usuarioId: string;
   emisoresIdList: string[];
   titulo: string;
}
